import { render } from "./EditTool.vue?vue&type=template&id=046848bc&scoped=true"
import script from "./EditTool.vue?vue&type=script&lang=js"
export * from "./EditTool.vue?vue&type=script&lang=js"

import "./EditTool.vue?vue&type=style&index=0&id=046848bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046848bc"]])

export default __exports__